import type {
  GridPaginationModel,
  GridSortModel,
  GridFilterModel
} from '@mui/x-data-grid';
import { buildWorkOrderODataFilter } from './buildWorkOrderODataFilter';

type ODataQueryParams = {
  $filter?: string;
  $select?: string;
  $orderby?: string;
  $top?: number;
  $skip?: number;
  $count?: boolean;
};

const buildOrderBy = (sortModel: GridSortModel): string | undefined => {
  if (!sortModel || sortModel.length === 0) {
    return undefined;
  }

  return sortModel
    .map(sort => {
      const field = capitalizeFirstLetter(sort.field);
      const direction = sort.sort === 'desc' ? 'desc' : 'asc';
      return `${field} ${direction}`;
    })
    .join(',');
};

const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const buildWorkOrderODataParams = (
  paginationModel: GridPaginationModel,
  sortModel: GridSortModel,
  filterModel: GridFilterModel,
  searchText: string
): ODataQueryParams => {
  const $filter = buildWorkOrderODataFilter({
    gridFilterModel: filterModel,
    searchText
  });

  const $orderby = buildOrderBy(sortModel);
  const $skip = paginationModel.page * paginationModel.pageSize;
  const $top = paginationModel.pageSize;

  return {
    $filter,
    $orderby,
    $skip,
    $top,
    $count: true
  };
};
